import { render, staticRenderFns } from "./ToolbarDialogToProjects.vue?vue&type=template&id=3dd348bc&scoped=true&"
import script from "./ToolbarDialogToProjects.vue?vue&type=script&lang=js&"
export * from "./ToolbarDialogToProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd348bc",
  null
  
)

export default component.exports